/**
 * Shared currencies list for use in Currency and Price property components
 */
export const CURRENCIES = [{
  code: 'USD',
  name: 'US Dollar',
  symbol: '$'
}, {
  code: 'EUR',
  name: 'Euro',
  symbol: '€'
}, {
  code: 'GBP',
  name: 'British Pound',
  symbol: '£'
}, {
  code: 'JPY',
  name: 'Japanese Yen',
  symbol: '¥'
}, {
  code: 'AUD',
  name: 'Australian Dollar',
  symbol: 'A$'
}, {
  code: 'CAD',
  name: 'Canadian Dollar',
  symbol: 'C$'
}, {
  code: 'CHF',
  name: 'Swiss Franc',
  symbol: 'CHF'
}, {
  code: 'CNY',
  name: 'Chinese Yuan',
  symbol: '¥'
}, {
  code: 'INR',
  name: 'Indian Rupee',
  symbol: '₹'
}, {
  code: 'BRL',
  name: 'Brazilian Real',
  symbol: 'R$'
}, {
  code: 'ZAR',
  name: 'South African Rand',
  symbol: 'R'
}, {
  code: 'RUB',
  name: 'Russian Ruble',
  symbol: '₽'
}, {
  code: 'MXN',
  name: 'Mexican Peso',
  symbol: '$'
}, {
  code: 'SGD',
  name: 'Singapore Dollar',
  symbol: 'S$'
}, {
  code: 'HKD',
  name: 'Hong Kong Dollar',
  symbol: 'HK$'
}, {
  code: 'NOK',
  name: 'Norwegian Krone',
  symbol: 'kr'
}, {
  code: 'SEK',
  name: 'Swedish Krona',
  symbol: 'kr'
}, {
  code: 'DKK',
  name: 'Danish Krone',
  symbol: 'kr'
}, {
  code: 'PLN',
  name: 'Polish Zloty',
  symbol: 'zł'
}, {
  code: 'TRY',
  name: 'Turkish Lira',
  symbol: '₺'
}, {
  code: 'KRW',
  name: 'South Korean Won',
  symbol: '₩'
}, {
  code: 'NZD',
  name: 'New Zealand Dollar',
  symbol: 'NZ$'
}, {
  code: 'AED',
  name: 'UAE Dirham',
  symbol: 'د.إ'
}, {
  code: 'SAR',
  name: 'Saudi Riyal',
  symbol: '﷼'
}, {
  code: 'THB',
  name: 'Thai Baht',
  symbol: '฿'
}, {
  code: 'MYR',
  name: 'Malaysian Ringgit',
  symbol: 'RM'
}, {
  code: 'IDR',
  name: 'Indonesian Rupiah',
  symbol: 'Rp'
}, {
  code: 'PHP',
  name: 'Philippine Peso',
  symbol: '₱'
},
// { code: 'ILS', name: 'Israeli Shekel', symbol: '₪' },
{
  code: 'EGP',
  name: 'Egyptian Pound',
  symbol: 'E£'
}];